import { HStack, IconButton, VStack } from '@genial/components';
import React from 'react';

import { TableContent, TableContentItemText } from '../../../../components/TableContent';
import {
  DoubleTextSkeleton,
  TextSkeleton,
} from '../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { CustomerNameLoading } from '../CustomerTableItem/shared/CustomerName';

export const ListLoadingItemTablet: React.FC = () => {
  return (
    <TableContent direction="row" space={0} p={0}>
      <HStack
        padding="inset.xs"
        space="inline.quarck"
        w="full"
        justifyContent="space-between"
        alignItems="center">
        <VStack space="stack.quarck" w="2/5">
          <CustomerNameLoading />
        </VStack>

        <VStack space="stack.quarck" w="1/6">
          <TableContentItemText variant="semibold">Conta de custódia</TableContentItemText>
          <TextSkeleton />
        </VStack>

        <VStack space="stack.quarck" w="1/6">
          <TableContentItemText color="neutral.black">CPF/CNPJ</TableContentItemText>
          <DoubleTextSkeleton />
        </VStack>

        <VStack space="stack.quarck" w="1/6">
          <TableContentItemText color="neutral.black">Cadastro</TableContentItemText>
          <DoubleTextSkeleton />
        </VStack>

        <IconButton
          testId="customers-table-item-desktop-action"
          icon="ChevronRight"
          iconSize="xxs"
          iconColor="neutral.light"
        />
      </HStack>
    </TableContent>
  );
};
